/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateJSONWebKeySetRequestBody,
  UpdateJSONWebKeySetRequestBody$Outbound,
  UpdateJSONWebKeySetRequestBody$outboundSchema,
} from "../components/updatejsonwebkeysetrequestbody.js";

export type UpdateJsonWebKeySetSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type UpdateJsonWebKeySetRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  updateJSONWebKeySetRequestBody: UpdateJSONWebKeySetRequestBody;
};

/** @internal */
export type UpdateJsonWebKeySetSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpdateJsonWebKeySetSecurity$outboundSchema: z.ZodMiniType<
  UpdateJsonWebKeySetSecurity$Outbound,
  UpdateJsonWebKeySetSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateJsonWebKeySetSecurityToJSON(
  updateJsonWebKeySetSecurity: UpdateJsonWebKeySetSecurity,
): string {
  return JSON.stringify(
    UpdateJsonWebKeySetSecurity$outboundSchema.parse(
      updateJsonWebKeySetSecurity,
    ),
  );
}

/** @internal */
export type UpdateJsonWebKeySetRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  UpdateJSONWebKeySetRequestBody: UpdateJSONWebKeySetRequestBody$Outbound;
};

/** @internal */
export const UpdateJsonWebKeySetRequest$outboundSchema: z.ZodMiniType<
  UpdateJsonWebKeySetRequest$Outbound,
  UpdateJsonWebKeySetRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    updateJSONWebKeySetRequestBody:
      UpdateJSONWebKeySetRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      updateJSONWebKeySetRequestBody: "UpdateJSONWebKeySetRequestBody",
    });
  }),
);

export function updateJsonWebKeySetRequestToJSON(
  updateJsonWebKeySetRequest: UpdateJsonWebKeySetRequest,
): string {
  return JSON.stringify(
    UpdateJsonWebKeySetRequest$outboundSchema.parse(updateJsonWebKeySetRequest),
  );
}
